<template>
    <div class="form-container">
      <!-- 标题部分 -->
      <div class="form-header">
        <h1 class="form-title">购买Telegram星星</h1>
        <p class="form-subtitle">为自己或你的朋友购买Telegram星星。</p>
      </div>
  
      <!-- 用户名输入 -->
      <a-form layout="vertical" class="purchase-form">
        <a-form-item label="输入接收Telegram用户" class="form-item">
          <p style="margin-top: 24px;">输入接收Telegram用户</p>
          <a-input
            v-model:value="username"
            placeholder="输入Telegram用户名，例如：@username"
            size="large"
            style="background-color: black;"
            class="dark-input"
          >
            <template #prefix>
              <user-outlined  style="color: aliceblue;"/>
            </template>
          </a-input>
        </a-form-item>
  
        <!-- 星星数量选择 -->
        <a-form-item label="选择购买数量" class="form-item">
          <p style="margin-top: 24px;">选择购买数量</p>
          <a-radio-group v-model:value="selectedAmount" class="stars-options">
            <a-radio-button
              v-for="option in starsOptions"
              :key="option.value"
              :value="option.value"
              class="stars-option"
            >
              <div class="option-content">
                <div class="option-title">
                  <star-filled v-for="n in option.stars" :key="n" class="star-icon" />
                  {{ option.label }}
                </div>
                <div class="option-price">
                  {{ option.price }}
                </div>
              </div>
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
  
        <!-- 购买按钮 -->
        <a-button
          type="primary"
          size="large"
          block
          class="purchase-btn"
          @click="handlePurchase"
        >
          立即购买
        </a-button>
      </a-form>
    </div>
  </template>
  
  <script>
  import { UserOutlined, StarFilled } from '@ant-design/icons-vue';
  import { message } from 'ant-design-vue';
  import { addOrder } from '../util/api'; 
  
  export default {
    name: 'StarsForm',
    components: {
      UserOutlined,
      StarFilled
    },
   
    data() {
      return {
        referral_code:"",
        username: '',
        selectedAmount: '50',
        starsOptions: [
          {
            value: '50',
            label: '50 Stars',
            stars: 1,
            price: '1.00'
          },
          {
            value: '100',
            label: '100 Stars',
            stars: 2,
            price: '2.00'
          },
          {
            value: '200',
            label: '200 Stars',
            stars: 2,
            price: '4.00'
          },
          {
            value: '500',
            label: '500 Stars',
            stars: 3,
            price: '10.00'
          },
          {
            value: '1000',
            label: '1000 Stars',
            stars: 3,
            price: '20.00'
          },
          {
            value: '2000',
            label: '2K Stars',
            stars: 4,
            price: '40.00'
          },
          {
            value: '5000',
            label: '5K Stars',
            stars: 5,
            price: '95.00'
          }
        ]
      };
    },

    methods: {
     async  handlePurchase() {
      const params = new URLSearchParams(window.location.search);
        this.referral_code = params.get("code") || '';
        
        if (!this.username) {
          message.warning('请输入Telegram用户名');
          return;
        }
  
        const selectedOption = this.starsOptions.find(
          option => option.value === this.selectedAmount
        );

        let str = this.getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
        let data = {
            price:selectedOption.price,
            inputNumber:1,
            inputGT:this.username,
            orderNo: str,
            title:selectedOption.label+"会员",
            referral_code:this.referral_code
        }
  
        message.success(
          `即将为 ${this.username} 购买 ${selectedOption.label}，金额: ${selectedOption.price}`
        );

        await addOrder(data)

        this.$router.push({ name: 'Payment', params: { data: JSON.stringify(data) } });

      }
      ,
       getCurrentDateTime ()   {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
      }
    }
  };
  </script>
  
  <style scoped lang="less">
  .form-container {
    padding: 16px;
    color: #fff; /* 确保子组件文字也是白色 */
  
  
    .form-header {
      text-align: center;
      margin-bottom: 24px;
  
      .form-title {
        font-size: 20px;
        font-weight: 600;
        color: #fff;
        margin-bottom: 8px;
      }
  
      .form-subtitle {
        font-size: 14px;
        color: #fff;
      }
    }
  
    .form-item {
      margin-bottom: 24px;
  
      :deep(.ant-form-item-label) {
        font-weight: 500;
        padding-bottom: 8px;
      }
    }
  
    .stars-options {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 100%;
      border-radius: 12px;
  
      .stars-option {
        height: auto;
        padding: 12px 16px;
        text-align: left;
        line-height: 1.5;
        background: #000;
        border-radius: 12px;
        
  
        .option-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
  
          .option-title {
            font-weight: 500;
            display: flex;
            align-items: center;
            
            .star-icon {
              color: #faad14;
              margin-right: 4px;
            }
          }
  
          .option-price {
            font-weight: 600;
            color: #1890ff;
          }
        }
      }
    }
  
    .purchase-btn {
      height: 48px;
      font-size: 16px;
      font-weight: 500;
      margin-top: 24px;
    }
  }

  :deep(.stars-options) {
  .ant-radio-button-wrapper {
    /* 基础样式 */
    border: 1px solid transparent !important;
    background: rgba(255, 255, 255, 0.1) !important;
    transition: all 0.3s;
    
    /* 选中状态 */
    &.ant-radio-button-wrapper-checked {
      background: #1890ff !important;
      box-shadow: none !important;
    }
    
    /* 移除相邻边框 */
    &::before {
      display: none !important;
    }
  }
}

  
  </style>